export default {
    namespaced: true,
    state: () => ({
        search: "",
        status: "All",
        extendedFilter: null,
        tableOptions:
        {
            page: 1,
            itemsPerPage : 15,
            sortBy : [ "controldate" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_SEARCH (state, payload){
            state.search = payload;
        },
        SET_STATUS (state, payload){
            state.status = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
        }
    },
    getters: {
        getSearch: (state) => state.search,
        getStatus: (state) => state.status,
        getExtendedFilter: (state) => state.extendedFilter,
        getTableOptions: (state) => state.tableOptions,
    }
}